import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHome, faUser, faPersonFalling} from '@fortawesome/free-solid-svg-icons';

import '../css/style.css';
import '../css/bootstrap.css';

function TcfWatch() {
  return (
      <div className="TcfWatch">
        <div>
          <section id="body-top-menus">
            <div className="container-fluid">
              <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <Link to="/" className="navbar-brand">
                  <img src="img/dh40-logo.png" style={{height: '8vh'}} alt="DeinHaus4.0 Logo - Länger Leben Zuhause Niederbayern" />
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link to="/tcflabor" className="nav-link"><FontAwesomeIcon icon={faHome} /> Hausdaten</Link>
                  </li>
                  <li className="nav-item active">
                    <Link to="/tcfwatch" className="nav-link" style={{color: '#ED7D31'}}><FontAwesomeIcon icon={faUser} /> Gesundheitsdaten</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/falldetection" className="nav-link"><FontAwesomeIcon icon={faPersonFalling} /> Sturzerkennung</Link>
                  </li>
                  </ul>
                </div>
                <img src="img/Ministerium_logo.png" style={{height: '6vh', selfAlign: 'right'}} alt="Förderlogo des Bayerischen Staatsministeriums für Gesundheit und Pflege" />
              </nav>
            </div>
          </section>
          <section id="bodydata">
            <div id="bodyscan" className="container-fluid">
              <img src="img/dh40-body.png" alt="Reduzierte Darstellung Körper" />
              <div id="bodypin-1" className="box">
                <div className="text-mittel bodypin-text">
                  <p>Schlafsensor</p>
                  <p style={{marginBottom: '0px'}}>Schlafdauer</p><h4>7h 6min</h4>
                  <p style={{marginBottom: '0px'}}>Tiefschlaf</p><h4>2h 10min</h4>
                </div>
              </div>
              <div id="bodypin-2" className="box">
                <div className="text-mittel bodypin-text">
                  <p>Herzfrequenz</p>
                  <h4>68bpm</h4>
                </div>
              </div>
              <div id="bodypin-3" className="box">
                <div className="text-mittel bodypin-text">
                  <p>Gewicht</p>
                  <h4>59,9kg</h4>
                </div>
              </div>
              <div id="bodypin-4" className="box">
                <div className="text-lang bodypin-text">
                  <p>Schrittzähler</p>
                  <h4>8.324Schritte</h4>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
  );
}

export default TcfWatch;
